(ns nosco.ui.empty-states
  (:require
   [hx.react :as hx :refer [defnc]]
   [nosco.ui.components :as components])
  (:require-macros
   [nosco.figma-utils :refer [defmap]]))

(defmap empty-states-new
  {add-user "/img/empty-states/Variant=Add user.svg",
   archive "/img/empty-states/Variant=Archive.svg",
   user "/img/empty-states/Variant=User.svg",
   no-status "/img/empty-states/Variant=No status.svg",
   no-ideas-found "/img/empty-states/Variant=No ideas found.svg",
   channel-not-found "/img/empty-states/Variant=channel not found.svg",
   no-user-labels "/img/empty-states/Variant=No user labels.svg",
   channel "/img/empty-states/Variant=Channel.svg",
   channel-created "/img/empty-states/Variant=Channel created.svg",
   search "/img/empty-states/Variant=Search.svg",
   no-tags "/img/empty-states/Variant=No tags.svg",
   no-channel-yet "/img/empty-states/Variant=no channel yet.svg",
   broken-link "/img/empty-states/Variant=Broken link.svg",
   no-access "/img/empty-states/Variant=No access.svg",
   spaces "/img/empty-states/Variant=Spaces.svg",
   loading "/img/empty-states/Variant=Loading.svg",
   page-not-found "/img/empty-states/Variant=Page not found.svg",
   no-pages "/img/empty-states/Variant=No pages.svg"
   no-messages-found "/img/empty-states/Variant=No messages found.svg"
   no-messages-yet "/img/empty-states/Variant=No messages yet.svg"
   heatmap "/img/empty-states/Variant=Heatmap.svg"
   ai "/img/empty-states/Variant=AI.svg"})

(defnc BareEmptyState [{:keys [img-src img-height]}]
  [:div
   {:class "nosco-empty-state"}
   [components/StaticImage {:src img-src
                            :style {:height img-height
                                    :width "auto"}}]])

(defnc EmptyState
  "Note: description can contain a vector of strings where each string
  will get a line break (separate p)"
  [{:keys [heading description img-src children img-height]}]
  [:div
   {:class "nosco-empty-state"}
   (when img-src
     [components/StaticImage {:src img-src
                              :style {:height img-height
                                      :width "auto"}}])

   [:h1 heading]
   (cond
     (string? description) [:p description]
     (vector? description) (for [p description] [:p p])
     :else nil)
   children])
